"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlaveStateManager = void 0;
var lodash_1 = __importDefault(require("lodash"));
var interpolateState_1 = require("./interpolateState");
var realms_engine_1 = require("realms-engine");
var SlaveStateManager = /** @class */ (function () {
    function SlaveStateManager(syncSchemaMap, options) {
        if (options === void 0) { options = {}; }
        var _a;
        // Ordered from latest to earliest
        this.statesBuffer = [];
        // Stores all realm changes that were received before a state exists
        this.changesBuffer = [];
        // The time the first packet was received
        this.timeOfFirstState = null;
        // The realm time (server time) when the first packet was received
        this.realmTimeOfFirstState = null;
        this.syncSchemaMap = syncSchemaMap;
        this.delay = (_a = options.stateDelay) !== null && _a !== void 0 ? _a : 100;
    }
    /**
     * On receiving a new state push it to the correct position.
     */
    SlaveStateManager.prototype.pushState = function (newState) {
        var e_1, _a;
        var _this = this;
        // Store first state time
        if (this.timeOfFirstState === null) {
            this.timeOfFirstState = performance.now();
            this.realmTimeOfFirstState = newState.realmTime;
        }
        var i = 0;
        var hasInserted = false;
        try {
            for (var _b = __values(this.statesBuffer), _c = _b.next(); !_c.done; _c = _b.next()) {
                var state = _c.value;
                if (newState.realmTime > state.realmTime) {
                    this.statesBuffer.splice(i, 0, newState);
                    hasInserted = true;
                    break;
                }
                i++;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // oldest state so add it there
        if (!hasInserted) {
            this.statesBuffer.push(newState);
        }
        // Add changes to buffer
        var oldestState = this.statesBuffer[this.statesBuffer.length - 1];
        this.changesBuffer.forEach(function (change) {
            if (change.realmTime > oldestState.realmTime) {
                _this.pushChange(change);
            }
        });
        // Clear buffer
        this.changesBuffer = [];
    };
    /**
     * Push a change onto the realm states. If no state exists
     * It will be stored in a buffer
     */
    SlaveStateManager.prototype.pushChange = function (change) {
        var e_2, _a;
        // Find the state just before this change time
        var i = 0;
        var hasInserted = false;
        try {
            for (var _b = __values(this.statesBuffer), _c = _b.next(); !_c.done; _c = _b.next()) {
                var state = _c.value;
                if (change.realmTime > state.realmTime) {
                    this.statesBuffer.splice(i, 0, this.applyChanges(state, change));
                    hasInserted = true;
                    break;
                }
                i++;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        // Add to buffer to be applied when a state
        // is received
        if (!hasInserted) {
            this.changesBuffer.push(change);
        }
    };
    /**
     * Gets the time of the realm on the server.
     * Will return null if the first packet has not been received from the server
     */
    SlaveStateManager.prototype.getCurrentRealmTime = function () {
        if (this.realmTimeOfFirstState === null || this.timeOfFirstState === null) {
            return null;
        }
        return (this.realmTimeOfFirstState + (performance.now() - this.timeOfFirstState));
    };
    /**
     * Gets the time of the master state. The master state will always be slightly
     * behind the "server" time as we need to delay it for interpolation.
     *
     * This is equivalent to the timestamp of the state being rendered on screen right now
     * (for non client side prediction objects)
     */
    SlaveStateManager.prototype.getMasterStateTime = function () {
        var currentRealmTime = this.getCurrentRealmTime();
        if (currentRealmTime === null) {
            return null;
        }
        return currentRealmTime - this.delay;
    };
    /**
     * Gets the current state to display on client taking into account the delay for
     * interpolation
     */
    SlaveStateManager.prototype.getCurrentMasterState = function () {
        var masterStateTime = this.getMasterStateTime();
        if (masterStateTime === null) {
            return null;
        }
        return this.getState(masterStateTime);
    };
    /*
     * Given the current realmTime, get the current realm state
     * and also resize buffers
     */
    SlaveStateManager.prototype.getState = function (realmTime) {
        var e_3, _a;
        // No states
        if (this.getStatesBuffer().length === 0) {
            return null;
        }
        // Loop to the state that has a realmtime just before the given realm time
        var i = 0;
        var found = false;
        try {
            for (var _b = __values(this.getStatesBuffer()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var state = _c.value;
                if (realmTime > state.realmTime) {
                    found = true;
                    break;
                }
                i++;
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        // No state earlier than current time so just return the earliest one
        if (!found) {
            return this.getStatesBuffer()[this.getStatesBuffer().length - 1];
        } // Remove all states older than current index
        this.statesBuffer.splice(i + 1, this.getStatesBuffer().length - i - 1);
        // RealmTime is later than latest state
        // so just return latest one "lags"
        if (i === 0) {
            return this.getStatesBuffer()[0];
        }
        return this.interpolateStates(this.getStatesBuffer()[i], this.getStatesBuffer()[i - 1], realmTime);
    };
    // Interpolates between two states
    SlaveStateManager.prototype.interpolateStates = function (oldState, newState, realmTime) {
        var e_4, _a;
        // Time interpolated to between 0 to 1
        var interpolatedTime = Math.max(realmTime - oldState.realmTime, 0) /
            (newState.realmTime - oldState.realmTime);
        var lerpedGameObjects = [];
        var oldStateGameObjects = new Map(oldState.gameObjects.map(function (c) { return [c.id, c]; }));
        try {
            // Interpolate existing and new gameObjects
            // GameObjects that exist in the old state but not the new are ignored
            for (var _b = __values(newState.gameObjects), _c = _b.next(); !_c.done; _c = _b.next()) {
                var newStateComp = _c.value;
                var oldStateComp = oldStateGameObjects.get(newStateComp.id);
                // Add new gameObject
                if (oldStateComp === undefined) {
                    // Only add new gameObject when half way between the two states
                    if (interpolatedTime >= 0.5) {
                        lerpedGameObjects.push(lodash_1.default.cloneDeep(newStateComp));
                    }
                }
                else {
                    // Add interpolated gameObject
                    lerpedGameObjects.push({
                        id: oldStateComp.id,
                        type: oldStateComp.type,
                        state: (0, interpolateState_1.interpolateState)(oldStateComp.state, newStateComp.state, interpolatedTime, this.syncSchemaMap[oldStateComp.type]),
                    });
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return {
            realmTime: realmTime,
            gameObjects: lerpedGameObjects,
        };
    };
    SlaveStateManager.prototype.getStatesBuffer = function () {
        return this.statesBuffer;
    };
    SlaveStateManager.prototype.getChangesBuffer = function () {
        return this.changesBuffer;
    };
    // Applies the given changes to an old state
    SlaveStateManager.prototype.applyChanges = function (state, change) {
        var deletedIds = new Set(change.deletes);
        // Maps gameObject id to their changes
        var changesMap = new Map(change.changes.map(function (c) { return [c.id, c.changes]; }));
        var newState = {
            realmTime: change.realmTime,
            gameObjects: state.gameObjects
                // Remove all deleted gameObjects
                .filter(function (state) { return !deletedIds.has(state.id); })
                // Change changed gameObjects and leave
                // unchanged gameObjects
                .map(function (state) {
                if (changesMap.has(state.id)) {
                    return {
                        id: state.id,
                        type: state.type,
                        state: (0, realms_engine_1.mergeChanges)(state.state, changesMap.get(state.id)),
                    };
                }
                return state;
            })
                // Add new changes
                .concat(change.creates),
        };
        return newState;
    };
    return SlaveStateManager;
}());
exports.SlaveStateManager = SlaveStateManager;
